import MainPagos from '@/views/administracion/pagos/Main.vue';
import Default from '@/views/administracion/pagos/Default.vue';
import MainWep from '@/views/administracion/pagos/pagos/Main.vue';

const auth = ['Pagos:ver'];
const scopes = ['Pagos:crear', 'Pagos:editar', 'Pagos:eliminar'];

const pagos = [
  {
    path: 'pagos',
    meta: {
      title: 'Pagos',
      auth,
      scopes,
    },
    component: MainPagos,
    children: [
      {
        name: 'pagosPrincipal',
        path: '/',
        meta: {
          title: 'Pagos',
          auth,
          scopes,
        },
        component: Default,
        children: [],
      },
      {
        name: 'solicitudes',
        path: 'solicitudes',
        meta: {
          title: 'Pagos',
          auth,
          scopes,
        },
        component: Default,
        children: [],
      },
      {
        name: 'pagos',
        path: 'pagos',
        meta: {
          title: 'Pagos',
          auth,
          scopes,
        },
        component: MainWep,
        children: [],
      },
    ],
  },
];

export default pagos;
